module.exports = __webpack_public_path__ + "img/pencil-alt.7453b6a.png";